import React from 'react';
import { BlockRenderer } from '../renderer';
import { getNumberedListIndex } from '../utils/indentUtils';

/**
 * ColumnBlock — invisible layout container holding a vertical stack of
 * blocks inside a row. Blocks inserted above/below a block in a column
 * stack within it; a nested row inside a column gives nested columns.
 */
export const ColumnBlock = ({ block, ...passThrough }) => (
  <div className="column-block">
    {block.children?.map((child, i) => (
      <BlockRenderer
        key={child.id}
        {...passThrough}
        block={child}
        prevType={block.children[i - 1]?.type}
        nextType={block.children[i + 1]?.type}
        listNumber={
          child.type === 'number' ? getNumberedListIndex(block.children, i) : undefined
        }
      />
    ))}
  </div>
);
